import { Fab } from '@mui/material';
import {HelpCenterRounded, SchoolRounded} from "@mui/icons-material";

const Refresh = ({ onClick }) => (
  <Fab color="primary" aria-label="refresh" style={{ position: 'fixed', right: 20, bottom: 20 }} onClick={onClick}>
    <SchoolRounded />
  </Fab>
);

export default Refresh;